var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10812",
    "data-name": "Grupo 10812",
    transform: "translate(1514 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-refresh-ccw",
    "data-name": "Icon feather-refresh-ccw",
    transform: "translate(-1509.5 386.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2135",
    "data-name": "Trazado 2135",
    d: "M1.5,6v4.773H6.273",
    transform: "translate(0 -0.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2136",
    "data-name": "Trazado 2136",
    d: "M30.273,25.773V21H25.5",
    transform: "translate(-11.273 -7.748)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2137",
    "data-name": "Trazado 2137",
    d: "M17,9.274A7.159,7.159,0,0,0,5.191,6.6L1.5,10.07M19,13.252,15.309,16.72A7.159,7.159,0,0,1,3.5,14.047",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17744",
    "data-name": "Rect\\xE1ngulo 17744",
    width: 30,
    height: 30,
    transform: "translate(-1514 384)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17745",
    "data-name": "Rect\\xE1ngulo 17745",
    width: 30,
    height: 30,
    transform: "translate(-1514 384)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.23aee5485d8d4b027a57e89ed66e5c3f.svg";
export { ForwardRef as ReactComponent };